module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/mtst1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fmtst1.png
// module id = rDFP
// module chunks = 93